(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gxauto-automation"]) return;
  try {
    

function gxautoInit(scope) {
 const root=scope.querySelector('#gxauto-root');
 if(!root||root.dataset.gxautoReady)return;
 root.dataset.gxautoReady='true';
 const tabs=Array.from(root.querySelectorAll('[data-gxauto-tab]'));
 const panels=Array.from(root.querySelectorAll('[data-gxauto-panel]'));
 function activate(index,focus) {
  tabs.forEach((tab,i)=>{
   const active=i===index;
   tab.setAttribute('aria-selected',String(active));
   tab.tabIndex=active?0:-1;
   tab.toggleAttribute('data-active',active);
   panels[i].hidden=!active;
  });
  if(focus)tabs[index].focus();
 }
 tabs.forEach((tab,index)=>{
  tab.addEventListener('click',()=>activate(index,false));
  tab.addEventListener('keydown',event=>{
   let next=index;
   if(event.key==='ArrowDown'||event.key==='ArrowRight')next=(index+1)%tabs.length;
   else if(event.key==='ArrowUp'||event.key==='ArrowLeft')next=(index+tabs.length-1)%tabs.length;
   else if(event.key==='Home')next=0;
   else if(event.key==='End')next=tabs.length-1;
   else return;
   event.preventDefault();activate(next,true);
  });
 });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>gxautoInit(document));
else gxautoInit(document);
document.addEventListener('shopify:section:load',event=>gxautoInit(event.target));


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gxcip-cleaning"]) return;
  try {
    

function gxcipInit(scope) {
 const root=scope.querySelector('#gxcip-root');
 if(!root||root.dataset.gxcipReady)return;
 root.dataset.gxcipReady='true';
 const tabs=Array.from(root.querySelectorAll('[data-gxcip-tab]'));
 const panels=Array.from(root.querySelectorAll('[data-gxcip-panel]'));
 function activate(index,focus) {
  tabs.forEach((tab,i)=>{
   const active=i===index;
   tab.setAttribute('aria-selected',String(active));
   tab.tabIndex=active?0:-1;
   tab.toggleAttribute('data-active',active);
   panels[i].hidden=!active;
  });
  if(focus)tabs[index].focus();
 }
 tabs.forEach((tab,index)=>{
  tab.addEventListener('click',()=>activate(index,false));
  tab.addEventListener('keydown',event=>{
   let next=index;
   if(event.key==='ArrowDown'||event.key==='ArrowRight')next=(index+1)%tabs.length;
   else if(event.key==='ArrowUp'||event.key==='ArrowLeft')next=(index+tabs.length-1)%tabs.length;
   else if(event.key==='Home')next=0;
   else if(event.key==='End')next=tabs.length-1;
   else return;
   event.preventDefault();activate(next,true);
  });
 });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>gxcipInit(document));
else gxcipInit(document);
document.addEventListener('shopify:section:load',event=>gxcipInit(event.target));


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gxcu-critical-utilities"]) return;
  try {
    

function gxcuInit(scope) {
 const root=scope.querySelector('#gxcu-root');
 if(!root||root.dataset.gxcuReady)return;
 root.dataset.gxcuReady='true';
 const tabs=Array.from(root.querySelectorAll('[data-gxcu-tab]'));
 const panels=Array.from(root.querySelectorAll('[data-gxcu-panel]'));
 function activate(index,focus) {
  tabs.forEach((tab,i)=>{
   const active=i===index;
   tab.setAttribute('aria-selected',String(active));
   tab.tabIndex=active?0:-1;
   tab.toggleAttribute('data-active',active);
   panels[i].hidden=!active;
  });
  if(focus)tabs[index].focus();
 }
 tabs.forEach((tab,index)=>{
  tab.addEventListener('click',()=>activate(index,false));
  tab.addEventListener('keydown',event=>{
   let next=index;
   if(event.key==='ArrowDown'||event.key==='ArrowRight')next=(index+1)%tabs.length;
   else if(event.key==='ArrowUp'||event.key==='ArrowLeft')next=(index+tabs.length-1)%tabs.length;
   else if(event.key==='Home')next=0;
   else if(event.key==='End')next=tabs.length-1;
   else return;
   event.preventDefault();activate(next,true);
  });
 });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>gxcuInit(document));
else gxcuInit(document);
document.addEventListener('shopify:section:load',event=>gxcuInit(event.target));


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gxhp-containment"]) return;
  try {
    

function gxhpInit(scope) {
 const root=scope.querySelector('#gxhp-root');
 if(!root||root.dataset.gxhpReady)return;
 root.dataset.gxhpReady='true';
 const tabs=Array.from(root.querySelectorAll('[data-gxhp-tab]'));
 const panels=Array.from(root.querySelectorAll('[data-gxhp-panel]'));
 function activate(index,focus) {
  tabs.forEach((tab,i)=>{
   const active=i===index;
   tab.setAttribute('aria-selected',String(active));
   tab.tabIndex=active?0:-1;
   tab.toggleAttribute('data-active',active);
   panels[i].hidden=!active;
  });
  if(focus)tabs[index].focus();
 }
 tabs.forEach((tab,index)=>{
  tab.addEventListener('click',()=>activate(index,false));
  tab.addEventListener('keydown',event=>{
   let next=index;
   if(event.key==='ArrowDown'||event.key==='ArrowRight')next=(index+1)%tabs.length;
   else if(event.key==='ArrowUp'||event.key==='ArrowLeft')next=(index+tabs.length-1)%tabs.length;
   else if(event.key==='Home')next=0;
   else if(event.key==='End')next=tabs.length-1;
   else return;
   event.preventDefault();activate(next,true);
  });
 });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>gxhpInit(document));
else gxhpInit(document);
document.addEventListener('shopify:section:load',event=>gxhpInit(event.target));


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gxlyo-lyophilization"]) return;
  try {
    

function gxlyoInit(scope) {
 const root=scope.querySelector('#gxlyo-root');
 if(!root||root.dataset.gxlyoReady)return;
 root.dataset.gxlyoReady='true';
 const tabs=Array.from(root.querySelectorAll('[data-gxlyo-tab]'));
 const panels=Array.from(root.querySelectorAll('[data-gxlyo-panel]'));
 function activate(index,focus) {
  tabs.forEach((tab,i)=>{
   const active=i===index;
   tab.setAttribute('aria-selected',String(active));
   tab.tabIndex=active?0:-1;
   tab.toggleAttribute('data-active',active);
   panels[i].hidden=!active;
  });
  if(focus)tabs[index].focus();
 }
 tabs.forEach((tab,index)=>{
  tab.addEventListener('click',()=>activate(index,false));
  tab.addEventListener('keydown',event=>{
   let next=index;
   if(event.key==='ArrowDown'||event.key==='ArrowRight')next=(index+1)%tabs.length;
   else if(event.key==='ArrowUp'||event.key==='ArrowLeft')next=(index+tabs.length-1)%tabs.length;
   else if(event.key==='Home')next=0;
   else if(event.key==='End')next=tabs.length-1;
   else return;
   event.preventDefault();activate(next,true);
  });
 });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>gxlyoInit(document));
else gxlyoInit(document);
document.addEventListener('shopify:section:load',event=>gxlyoInit(event.target));


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gxpa-thematic"]) return;
  try {
    

function gxpaInit(scope) {
 const root=scope.querySelector('#gxpa-root');
 if(!root||root.dataset.gxpaReady)return;
 root.dataset.gxpaReady='true';
 const tabs=Array.from(root.querySelectorAll('[data-gxpa-tab]'));
 const panels=Array.from(root.querySelectorAll('[data-gxpa-panel]'));
 function activate(index,focus) {
  tabs.forEach((tab,i)=>{
   const active=i===index;
   tab.setAttribute('aria-selected',String(active));
   tab.tabIndex=active?0:-1;
   tab.toggleAttribute('data-active',active);
   panels[i].hidden=!active;
  });
  if(focus)tabs[index].focus();
 }
 tabs.forEach((tab,index)=>{
  tab.addEventListener('click',()=>activate(index,false));
  tab.addEventListener('keydown',event=>{
   let next=index;
   if(event.key==='ArrowDown'||event.key==='ArrowRight')next=(index+1)%tabs.length;
   else if(event.key==='ArrowUp'||event.key==='ArrowLeft')next=(index+tabs.length-1)%tabs.length;
   else if(event.key==='Home')next=0;
   else if(event.key==='End')next=tabs.length-1;
   else return;
   event.preventDefault();activate(next,true);
  });
 });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>gxpaInit(document));
else gxpaInit(document);
document.addEventListener('shopify:section:load',event=>gxpaInit(event.target));


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gxpc-cold-chain"]) return;
  try {
    

function gxpcInit(scope) {
 const root=scope.querySelector('#gxpc-root');
 if(!root||root.dataset.gxpcReady)return;
 root.dataset.gxpcReady='true';
 const tabs=Array.from(root.querySelectorAll('[data-gxpc-tab]'));
 const panels=Array.from(root.querySelectorAll('[data-gxpc-panel]'));
 function activate(index,focus) {
  tabs.forEach((tab,i)=>{
   const active=i===index;
   tab.setAttribute('aria-selected',String(active));
   tab.tabIndex=active?0:-1;
   tab.toggleAttribute('data-active',active);
   panels[i].hidden=!active;
  });
  if(focus)tabs[index].focus();
 }
 tabs.forEach((tab,index)=>{
  tab.addEventListener('click',()=>activate(index,false));
  tab.addEventListener('keydown',event=>{
   let next=index;
   if(event.key==='ArrowDown'||event.key==='ArrowRight')next=(index+1)%tabs.length;
   else if(event.key==='ArrowUp'||event.key==='ArrowLeft')next=(index+tabs.length-1)%tabs.length;
   else if(event.key==='Home')next=0;
   else if(event.key==='End')next=tabs.length-1;
   else return;
   event.preventDefault();activate(next,true);
  });
 });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>gxpcInit(document));
else gxpcInit(document);
document.addEventListener('shopify:section:load',event=>gxpcInit(event.target));


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gxster-sterilization"]) return;
  try {
    

function gxsterInit(scope) {
 const root=scope.querySelector('#gxster-root');
 if(!root||root.dataset.gxsterReady)return;
 root.dataset.gxsterReady='true';
 const tabs=Array.from(root.querySelectorAll('[data-gxster-tab]'));
 const panels=Array.from(root.querySelectorAll('[data-gxster-panel]'));
 function activate(index,focus) {
  tabs.forEach((tab,i)=>{
   const active=i===index;
   tab.setAttribute('aria-selected',String(active));
   tab.tabIndex=active?0:-1;
   tab.toggleAttribute('data-active',active);
   panels[i].hidden=!active;
  });
  if(focus)tabs[index].focus();
 }
 tabs.forEach((tab,index)=>{
  tab.addEventListener('click',()=>activate(index,false));
  tab.addEventListener('keydown',event=>{
   let next=index;
   if(event.key==='ArrowDown'||event.key==='ArrowRight')next=(index+1)%tabs.length;
   else if(event.key==='ArrowUp'||event.key==='ArrowLeft')next=(index+tabs.length-1)%tabs.length;
   else if(event.key==='Home')next=0;
   else if(event.key==='End')next=tabs.length-1;
   else return;
   event.preventDefault();activate(next,true);
  });
 });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>gxsterInit(document));
else gxsterInit(document);
document.addEventListener('shopify:section:load',event=>gxsterInit(event.target));


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gxsu-single-use"]) return;
  try {
    



function gxsuInit(scope) {

 const root=scope.querySelector('#gxsu-root');

 if(!root||root.dataset.gxsuReady)return;

 root.dataset.gxsuReady='true';

 const tabs=Array.from(root.querySelectorAll('[data-gxsu-tab]'));

 const panels=Array.from(root.querySelectorAll('[data-gxsu-panel]'));

 function activate(index,focus) {

  tabs.forEach((tab,i)=>{

   const active=i===index;

   tab.setAttribute('aria-selected',String(active));

   tab.tabIndex=active?0:-1;

   tab.toggleAttribute('data-active',active);

   panels[i].hidden=!active;

  });

  if(focus)tabs[index].focus();

 }

 tabs.forEach((tab,index)=>{

  tab.addEventListener('click',()=>activate(index,false));

  tab.addEventListener('keydown',event=>{

   let next=index;

   if(event.key==='ArrowDown'||event.key==='ArrowRight')next=(index+1)%tabs.length;

   else if(event.key==='ArrowUp'||event.key==='ArrowLeft')next=(index+tabs.length-1)%tabs.length;

   else if(event.key==='Home')next=0;

   else if(event.key==='End')next=tabs.length-1;

   else return;

   event.preventDefault();activate(next,true);

  });

 });

}

if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>gxsuInit(document));

else gxsuInit(document);

document.addEventListener('shopify:section:load',event=>gxsuInit(event.target));




  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
